import { LocalStorageKeys } from '@containers/App';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import { PillarNames } from '@interfaces/pillar';
import TicketEventLIServiceEhss from '@services/TicketEventLIService';
import TicketEventQAService from '@services/TicketEventQAService';
import TicketServiceEhss from '@services/TicketServiceEhss';

export default class TicketRequestsInterceptor {

    private ticketServiceEHSS: TicketServiceEhss = new TicketServiceEhss;
    private ticketServiceQA: TicketEventQAService = new TicketEventQAService;
    private ticketServiceLI: TicketEventLIServiceEhss = new TicketEventLIServiceEhss;
    private currentPillar: any;

    private idUnit: string = ''
    constructor() {

    }

    async paging(query: BasePaginationQuery, idProcess?: string, fields?: string[]): Promise<any> {
        this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
        this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

        let res;
        switch (this.currentPillar) {
            case PillarNames.EHSS:
                res = await this.ticketServiceEHSS.paging(query, idProcess, fields);
                break;
            case PillarNames.QA:
                res = await this.ticketServiceQA.paging(query, idProcess, fields);
                break;
            case PillarNames.LI:
                res = await this.ticketServiceLI.paging(query, idProcess, fields);
                break;
        }
        return res;
    }

    async pagingByRole(query: BasePaginationQuery, fields?: string[]): Promise<any> {
        this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
        this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

        let res;
        switch (this.currentPillar) {
            case PillarNames.EHSS:
                res = await this.ticketServiceEHSS.paging(query, fields);
                break;
            case PillarNames.QA:
                res = await this.ticketServiceQA.paging(query, fields);
                break;
            case PillarNames.LI:
                res = await this.ticketServiceLI.paging(query, fields);
                break;
        }
        return res;
    }
}